import(/* webpackMode: "eager", webpackExports: ["Flex","Space","Popover"] */ "__barrel_optimize__?names=Flex,Popover,Space!=!/root/iyiwutrade/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyiwutrade/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/components/footer/footer.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyiwutrade/src/components/header/MainHeader.js");
